var exports = {
  "uW": "section__LJDygt",
};

module.exports = exports;
